import React from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import * as Yup from 'yup';
import DisplayDockets from './DisplayDockets';
import { fetchDocketData,findDockets } from '../../../../actions/docketAction';
import { showHideModal,resetModalValues,showHideThankYouModal, notification } from '../../../../actions/uiAction';
import { getCookie } from "../../../../services/helper/Helper";
import { Link,NavLink,withRouter } from "react-router-dom";
import {mediaPath } from "../../../../config";
import { Control,actions, Field } from 'react-redux-form';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import moment from 'moment';
import Select from "react-select";
import {getDocumentTypes,changeAction,uploadDocFiles,getDockets} from '../../../../actions/docketGeneralInfoAction';
import {refreshNativeDataTable,showHideNotificationModal } from '../../../../actions/uiAction';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FooterContactSection } from '../../footer/FooterContactSection';
import Dropzone from "react-dropzone";
import paginationFactory from 'react-bootstrap-table2-paginator';
import {getCurrentUserData} from "../../../../services/http-services/HttpServices";
const dropzoneRef = React.createRef();
let dropzone = props => <Dropzone {...props} />;

const { SearchBar } = Search;

const uploadFilesSchema=Yup.object().shape({
				files: Yup.array()
				  .min(1,'Please drag a file here or choose a file to upload.'),
				documentName: Yup.string()
				  .matches(/^[ \w-_.,]+$/,  {
						message:'Please update the file name so it does not include a special character.',
						excludeEmptyString: true
				}),
				docketno: Yup.string()
				.matches(/^[0-9\b]+$/, {
						message:'Please enter a valid docket number.',
						excludeEmptyString: true
				})
				  .trim().required('Please select a docket number.'),
				  documentType: Yup.string()
				  .required('Please select a document type.'), 
			});

	class Dashboard  extends React.Component {
		
	constructor(props, context) {
    super(props, context);
	// let value=getCookie(btoa("publicAccess"));
	// let user_type = JSON.parse(atob(value)).user_type;
	let user_type = '';

    this.state = {
      show: false,
	  user_type:user_type,
	  uploadErrorId:'',
	  maxFileSize:262144000
    };
  }  

	asyncCall = async () =>  {
		//console.log('calling');
		const result = await getCurrentUserData();
		//console.log(result,4500);
		return result;
	}

	componentDidMount = async () => {
			this.props.getDocumentTypes();
			this.props.getDockets();
			this.props.showHideModal(false);

			let userData = await this.asyncCall();
			//console.log(userData,1500);
			this.setState({ user_type: userData.user_type });
	}
	
	handleClose(flag) {
		if(flag=='find_case')
		{
			this.setState({ show: false });
		}else if(flag=='thankyou')
		{
			this.props.showHideThankYouModal(false);
		}else{
			this.props.showHideModal(false);
			
		}
	}
	/* Function is used to close the modal */
	closeModal() {
		this.props.showHideNotificationModal(false);
	}
	handleCloseAfterSubmit() {
	  if(this.props.findCaseform.uniqueCode!='' && this.props.findCaseform.uniqueCode!=undefined)
	  {
		 this.setState({ show: false });
	  }
    
	}
	handleShow(flag) {
	  if(flag=='find_case')
	  {
		this.setState({ show: true });
		this.props.getDockets();
		this.props.resetModalValues("findCaseform.uniqueCode");
	  }else if(flag=='entryOfAppearance'){
		this.props.showHideModal(true);
		this.props.resetModalValues("uploadFile");
		this.setState({filesModal: false});
	  }else{
		this.props.showHideModal(true);
		this.props.resetModalValues("uploadFile");
		this.setState({filesModal: true,status: "open"});
	  }
    
  }
			componentDidUpdate(newProps,oldProps){
				if(newProps.match.params.status != this.props.match.params.status)
				{
						this.props.refreshNativeDataTable(document.querySelector('.table-button-menu-item[aria-label="refresh"]'))
				}
			}
			
			
	render(){
		
		let files=this.props.uploadFile.files;
		const documentTypesOptions = this.props.docketGeneralInfo || [];
		const caseids = this.props.caseids || [];	
		const data = this.props.docketData.docketData || [];
		
return (
		<div className="mydashboard-block">
			<div className="tab-block">
				<div className="container">
					<ul>
						<li>
							
								<NavLink to={"/publicAccess/dashboard/open"} activeClassName='active' exact>Active Cases</NavLink>
						</li>
						<li>
								
									<NavLink to={"/publicAccess/dashboard/Closed"} activeClassName='active' exact>Closed Cases</NavLink>
						</li>
					</ul>
					 <div className="action-btn-right">
						<button onClick={()=>this.handleShow("find_case")}  data-toggle="modal" data-target="#find-case">Find Case</button>
						{this.props.match.params.status!='Closed' ? <button data-toggle="modal" onClick={()=>{this.handleShow("files")}} data-target="#upload-files">eFile Docs for Your Case</button> : <div></div>}
						{this.props.match.params.status!='Closed' && this.state.user_type=='1' ? <button data-toggle="modal" onClick={()=>{this.handleShow("entryOfAppearance")}} data-target="#upload-files">Submit Entry of Appearance</button> : <div></div>}
					</div>
				</div>
			</div>
			<div className="mydocket-block">
				<div className="container">
					<div className="col-xs-12">
						<div className="mydocket-table">	
	<DisplayDockets status={this.props.match.params.status}/>
						</div>
					</div> 
				</div> 
			</div>
			<Modal show={this.props.uiState.modalHideShow} 
                  onHide={()=>this.handleClose("files")} 
                  backdrop="static" id="upload-files"
                  className="modal fade select-files">
				<Modal.Header>
                    <button type="button" className="close" onClick={()=>this.handleClose("files")} ><img src={mediaPath+"close.png"} alt="close modal" /></button>
					<h4 className="modal-title">eFile Documents</h4>
				</Modal.Header>
				<Modal.Body>
						<div className="row">
							<div className="col-xs-12">
								<p className="note">OSAH is not responsible for any documents that have been uploaded with confidential information.</p>
							</div>
						</div>
                        <div className="row">
							<div className="col-xs-6">
								<label aria-label="Docket Number">Docket Number *
								{this.state.filesModal ? <Control.custom
									component={props => <Select aria-required="true" aria-labelledby="Docket Number" {...props} className="react-select" />}
									model="uploadFile.docketno"
									options={caseids} 
									getOptionLabel={({ caseid}) => caseid} 
									getOptionValue={({ caseid}) => caseid}
									value={caseids.find(v=>v.caseid===this.props.uploadFile.docketno)}
									mapProps={{ onChange: (props) => props.onChange}}
									changeAction= { (model, value)=>
									  dispatch => {
											dispatch(actions.change('uploadFile.docketno', value.caseid))
										}
									}
								/>:<Control.text model="uploadFile.docketno" aria-labelledby="Docket Number" required value={this.props.uploadFile.docketno}
								changeAction= { (model, value)=>
									  dispatch => {
											dispatch(actions.change(model, value))
											dispatch(actions.change('uploadFile.documentType', "Entry Of Appearance"))
										}
									}/>
								}</label>
								
                            </div>
                            <div className="col-xs-6">
                                <label aria-label="Document Type">Document Type *
								{this.state.filesModal ?<Control.custom
									component={props => <Select aria-required="true" {...props} className="react-select" />}
									model="uploadFile.documentType"
									options={documentTypesOptions} 
									getOptionLabel={({ documenttype}) => documenttype} 
									getOptionValue={({ documenttype}) => documenttype}
									value={documentTypesOptions.find(v=>v.documenttype===this.props.uploadFile.documentType)}
									mapProps={{ onChange: (props) => props.onChange}}
									changeAction= { (model, value)=>
									  dispatch => {
											dispatch(actions.change('uploadFile.documentType', value.documenttype))
										}
									}
								/>:<Control.text model="uploadFile.documentType" aria-labelledby="Docket Number" required disabled value={"Entry Of Appearance"}
								/>}</label>
                            </div>
                        </div>
						<div className="row">
                            <div className="col-xs-12">
                                <label htmlFor="document-name" aria-label="Document Name">Document Name*</label>
                               <Control.text id="document-name" aria-required="true"  aria-labelledby="Document Name"  model="uploadFile.documentName" disabled required value={this.props.uploadFile.documentName ? this.props.uploadFile.documentName :'' }/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <label htmlFor="description" aria-label="Description">Description</label>
                               <Control.textarea id="description" aria-labelledby="Description" model="uploadFile.description" required value={this.props.uploadFile.description}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <label aria-label="Add Files">Add Files*</label>
                                <Control.custom
                            component={dropzone}
                            model="uploadFile.files"
                            mapProps={{onDrop: (props) => props.onChange}}
                            disableClick={this.props.uploadFile.files.length?true:false} 
                            multiple={false}
                            ref={dropzoneRef}
							minSize={1024}
							maxSize={this.state.maxFileSize}
							accept= ".png,.jpeg,.jpg,.pdf"
                            className="dropzone-container"
                          >
						  	{({rejectedFiles}) =>(
                            <div className={"textarea-section"+(this.props.uploadFile.files.length?' files-listed ':'')} >
								{rejectedFiles.length&&rejectedFiles[0].preview!=this.state.uploadErrorId?(
									this.setState({uploadErrorId:rejectedFiles[0].preview}),
									this.props.notification(
										(rejectedFiles[0].size>=this.state.maxFileSize)?'Please upload a file that is less than 250MB.':'Please upload an accepted file type.'
									)
								)
								:''}
                              <div className={"textarea-section-inner"+(this.props.uploadFile.files.length?' hide ':'')}>
                                <span>Drag & Drop File Here</span>
                                <span>or</span>
                                <a className="btn">Choose File to Upload</a>
                              </div>
                              {this.props.uploadFile.files.map((f,k) => (
                                (f.name && <div  key={k} className="dz-preview dz-file-preview dz-processing dz-success dz-complete">
                                  <div className="dz-image">
                                  { ['image/png','image/jpeg','image/jpg'].indexOf(f.type)>=0 &&
                                    <div className="img" style={{background:"url("+f.preview+")"}}>
                                    </div>
                                  }
                                  </div>
                                  <div className="dz-details">
                                    <div className="dz-filename"><span>{f.name}</span></div>
									{this.props.changeAction("uploadFile.documentName",f.name)}
                                  </div>
                                  <div className="dz-error-message"><span>This is error</span></div>
                                  <a href="javascript:;" className="dz-remove" onClick={()=>{
                                    let _files = [...files];
                                    _files.splice(k, 1);
                                    this.props.changeAction("uploadFile.files",_files)
                                    this.props.changeAction("uploadFile.documentName",_files)
                                  }}>Remove file</a>
                                </div>)
                              ))}
                              <div onClick={() => { dropzoneRef.current.open() }} className={"dz-preview dz-file-preview dz-processing dz-success dz-complete"+(files.length&&dropzoneRef&&dropzoneRef.current&&dropzoneRef.current.props.multiple?'':' hide ')}>
                                <div className="dz-image add-more-files">
                                  <div className={"textarea-section-inner"}>
                                    <span>Drag & Drop File Here</span>
                                    <span>or</span>
                                    <span>Choose File to Upload</span>
                                  </div>
                                </div>
                              </div>
                            </div>
							)}
                          </Control.custom>
						  <p className="note">Note: You can only upload one file at a time. Files should be no larger than 250MB. Accepted file types are PDF, JPG and PNG. File names should not contain special characters such as: !@#$%^&*().</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <p>* Required</p>
                            </div>
                        </div>	
				</Modal.Body>
				<Modal.Footer>
					<div className="btn-block">
						<button type="button" className="btn cancel"  onClick={()=>this.handleClose("files")}>{this.state.filesModal ? 'Close' : 'Cancel'}</button>
						
						<button type="button" className="btn btn-default" onClick={()=>this.props.uploadDocFiles(this.props.uploadFile,uploadFilesSchema)}> {this.state.filesModal ? <i className="fa fa-paperclip" aria-hidden="true"></i> : ''} {this.state.filesModal ? 'eFile' : 'Submit'}</button>
					</div>
				</Modal.Footer>
			</Modal>
			<Modal show={this.state.show} 
                  onHide={()=>this.handleClose("find_case")} 
                  backdrop="static" id="find-case"
                  className="select-files">
                  <Modal.Header>
                    <button type="button" className="close" onClick={()=>this.handleClose("find_case")} ><img src={mediaPath+"close.png"} alt="close modal" /></button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
						<div className="col-xs-12">
								<p className="note">Please enter your unique 8 digit code<br/> found on your Notice of Hearing</p>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
							<Control.text model="findCaseform.uniqueCode" aria-required="true" aria-label="Please enter your unique 8 digit code found on your Notice of Hearing" required value={this.props.findCaseform.uniqueCode}/>
						</div>
					</div>	
					{/* <div className="row">
						<div className="col-xs-12">
							<div className="eservice-block">
								<div className="eservice-heading-block">
									<label aria-label="Email preferences" className="eservice-heading">eService preference</label>
									<div className="overview-optedtooltip">
										<i class="fa fa-info-circle" aria-hidden="true"></i>
										<span className="tooltiptext" >By opting in to eService, you are consenting to receive all filings from the Court electronically.  You also consent for any opposing parties of record to serve you electronically through ePortal, and <b>you thereby waive the right to service by the means described under Ga. Comp. R. & Regs. 616-1-2-.11.</b>  Any service requirements otherwise provided by law shall remain in effect.</span>
									</div>	
								</div>
								<Field model="findCaseform.e_services" >
									<div className="radio-block" role="radiogroup" tabIndex="0">
										<span>
											<input role="radio" id="opt-in" aria-label="Opt-in"  name="preference" type="radio" className="field radio" value="1" checked={this.props.findCaseform.e_services==='1'}/>
											<label className="" htmlFor="opt-in" >
												<span className="choice__text">Opt-in</span>
											</label>
										</span>
										<span>
											<input role="radio" id="opt-out" aria-label="Opt-out" name="preference" type="radio" className="field radio" value="0" checked={this.props.findCaseform.e_services==='0'}/>
											<label className="" htmlFor="opt-out" >
												<span className="choice__text">Opt-out</span>
											</label>
										</span>						
									</div>
								</Field>
							</div>
                        </div>
					</div>					 */}
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="btn-block">
                      <button type="button" className="btn cancel"  onClick={()=>this.handleClose("find_case")}>Cancel</button>
                      <button type="button" onClick={()=>{this.props.findDockets({unique_code:this.props.findCaseform.uniqueCode/*,eServices:this.props.findCaseform.e_services*/});this.handleCloseAfterSubmit()}}  className="btn btn-default">Submit</button>
                    </div>
                  </Modal.Footer>
                </Modal>
				
				<Modal show={this.props.uiState.hideShowThankYouModal} 
                  onHide={()=>this.handleClose()} 
                  backdrop="static" id="doc-thankyou"
                  className="modal fade">
                  <Modal.Header>
                    <button type="button" onClick={()=>this.handleClose("thankyou")} className="close" data-dismiss="modal">
						<img src={mediaPath+"close.png"} alt="close" />
					</button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
						<div className="col-xs-12">
							<h2>Thank you!</h2>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
							<p className="note">Your documents have been uploaded. Please allow 24-48 hours for your document to be reviewed and added to the docket.</p>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
								<p className="note">If something is incorrect or missing, your document will be rejected and you will receive an email notification with specific instructions to correct the error.</p>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
						<div className="reminder">
						<p className="note">
								<h4>REMINDER:</h4>  
								Submitting documents via ePortal does NOT satisfy service requirements.  You are still required to simultaneously deliver copies of your documents to opposing parties (by first-class mail, email, fax, personal delivery).  You must also submit proof of service to OSAH. <a className="notice-link" href="https://eportal.osah.ga.gov/eService requirements/administrative_rules_osah.pdf" target="_blank"><span>Click here</span> review OSAH's Service Rule, 616-1-2-.11.</a> 
							</p>
						</div>
							
						</div>
					</div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="btn-block">
                      <button type="button" onClick={()=>this.handleClose("thankyou")} className="btn cancel">Close Window</button>
                    </div>
                  </Modal.Footer>
                </Modal>	
				<Modal show={this.props.uiState.notificationFlag} 
                  onHide={()=>this.closeModal()} 
                  backdrop="static" id="find-case"
                  className="modal fade select-files">
                  <Modal.Header>
                    <button type="button" className="close" onClick={()=>this.closeModal()} ><img src={mediaPath+"close.png"} alt="close" /></button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
						<div className="col-xs-12">
								<p className="note">Thank you for logging into ePortal. You have a new case available. An email has been sent to you with instructions on how to access your case.</p>
						</div>
					</div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="btn-block">
                      <button type="button" className="btn cancel" onClick={()=>this.closeModal()}>Close</button>
                    </div>
                  </Modal.Footer>
                </Modal>	
				<FooterContactSection/>
			</div> 
  

	)
	}
}

function mapStateToProps(state) {
	return {
	  docketData : state.docketData,
	  docketStatus : state.docketData ? state.docketData.docketStatus : {},
	  findCaseform : state.findCaseform,
	  uploadFile : state.uploadFile,
	  uiState : state.uiState,
	  docketGeneralInfo : state.docketGeneralInfo.documentTypes,
	  caseids : state.docketGeneralInfo.caseids
  };
}

export default connect(mapStateToProps, {fetchDocketData,findDockets,showHideModal,getDocumentTypes,changeAction,uploadDocFiles,resetModalValues,showHideThankYouModal,notification,refreshNativeDataTable,getDockets,showHideNotificationModal})(Dashboard);
